import { Divisor, Nav } from "@ligo/layout-design-core";
import { ReactComponent as LeftArrowIcon } from "assets/icons/leftArrow.svg";
import { ReactComponent as Logo } from "assets/imgs/logo.svg";
import { ReactComponent as LogoIcon } from "assets/imgs/logoIcon.svg";
import { ReactComponent as DocumentationIcon } from "assets/sidebar/document.svg";
import { ReactComponent as ProjectIcon } from "assets/sidebar/project.svg";
import { ReactComponent as TelemetryIcon } from "assets/sidebar/telemetry.svg";
import NavDropdown from "components/navDropdown";
import { documentationPath } from "consts";
import { NavLink } from "react-router-dom";
import { NavButton, NavContent, SideBarContainer } from "./styles";
import useViewModel from "./viewModel";

const SideBar = () => {
  const vm = useViewModel();
  const { isCollapsed, selectedProject, hasUser, profileItems, navItems } = vm;
  const { t, onOpenProjectSelect, handleToggleCollapse, onOpenTelemetry } = vm;

  return (
    <SideBarContainer $isCollapsed={isCollapsed}>
      <NavButton
        $isCollapsed={isCollapsed}
        icon={<LeftArrowIcon />}
        onClick={handleToggleCollapse}
      />
      <div>
        <NavLink to="/">
          {isCollapsed ? <LogoIcon width="100%" /> : <Logo />}
        </NavLink>
        <NavContent>
          {profileItems?.map((item, index) =>
            item.subItems?.length ? (
              <NavDropdown
                key={index}
                text={item.name}
                icon={item.icon}
                label={item.label}
                $disable={!hasUser}
                items={item.subItems}
                $justIcon={isCollapsed}
              />
            ) : (
              <NavLink key={index} to={hasUser ? item.path! : ""}>
                {({ isActive }: { isActive: boolean }) => (
                  <Nav
                    icon={item.icon}
                    name={item.name}
                    label={item.label}
                    justIcon={isCollapsed}
                    $isActive={hasUser && isActive}
                  />
                )}
              </NavLink>
            )
          )}
          <Nav
            icon={<ProjectIcon />}
            justIcon={isCollapsed}
            onClick={onOpenProjectSelect}
            label={t("sideBar.project")}
            name={selectedProject?.DeProject ?? "..."}
          />
          <Divisor />
          {navItems?.map((item, index) =>
            item.subItems?.length ? (
              <NavDropdown
                key={index}
                text={item.name}
                icon={item.icon}
                $disable={!hasUser}
                items={item.subItems}
                $justIcon={isCollapsed}
              />
            ) : (
              <NavLink key={index} to={hasUser ? item.path! : ""}>
                {({ isActive }: { isActive: boolean }) => (
                  <Nav
                    icon={item.icon}
                    name={item.name}
                    justIcon={isCollapsed}
                    $isActive={hasUser && isActive}
                  />
                )}
              </NavLink>
            )
          )}
          <Divisor />
          <Nav
            justIcon={isCollapsed}
            icon={<TelemetryIcon />}
            onClick={onOpenTelemetry}
            name={t("sideBar.telemetry")}
          />
          <a href={documentationPath} target="_blank" rel="noreferrer">
            <Nav
              justIcon={isCollapsed}
              icon={<DocumentationIcon />}
              name={t("sideBar.documentation")}
            />
          </a>
        </NavContent>
      </div>
    </SideBarContainer>
  );
};

export default SideBar;
